import React from 'react';
import { makeStyles } from '@material-ui/core';
import VectorIcon from './VectorIcon';

type Props = {
  isBlink?: boolean;
  radius?: number;
};

const useStyles = makeStyles({
  '@keyframes blinker': {
    '50%': {
      opacity: 0,
    },
  },
  blink: {
    animation: '$blinker 1s linear infinite',
  },
});

const StarBlinkIcon = ({
  isBlink = false,
  radius = 18,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <VectorIcon width={radius} height={radius}>
      <path
        className={isBlink ? classes.blink : ''}
        d="M9.25 1.50342L11.5675 6.19842L16.75 6.95592L13 10.6084L13.885 15.7684L9.25 13.3309L4.615 15.7684L5.5 10.6084L1.75 6.95592L6.9325 6.19842L9.25 1.50342Z"
        fill="#FFB800"
        stroke="#FFB800"
      />
    </VectorIcon>
  );
};

export default StarBlinkIcon;
